
<form>
    <div class="route-picker-2" *ngIf="showFullName">
        Sorted By {{ jurisSortStr }}:
        <input type="radio" [(ngModel)]="sortRouteBy" value="number" name="rt" style="margin: 2px 5px 2px 20px;" (change)="routeSortChange()" />
        <label>Route Number</label>
        <input type="radio" [(ngModel)]="sortRouteBy" value="name" name="rt" style="margin: 2px 5px 2px 20px;" (change)="routeSortChange()" />
        <label>Route Name</label>
    </div>

    <div id="info" [className]="showOffset ? 'route-picker-3' : 'route-picker'">
        <label>
            County
            <select class="select" [(ngModel)]="county" name="county" id="county">
                <option *ngFor="let county of counties" [ngValue]="county">{{ county.name }} ({{ county.countyCode }})</option>
            </select>
        </label>
        <label *ngIf="jurisSort">
            Jurisdiction (Optional)
            <select class="select" [(ngModel)]="jurisValues" name="juris" [disabled]="!county">
                <option *ngFor="let juris of jurisOptions" [ngValue]="juris.values">{{ juris.name }}</option>
            </select>
        </label>
        <label>
            Route
            <select class="select" style="max-width: 250px;" [(ngModel)]="route" name="route" id="route" [disabled]="!county">
                <option title="{{route.fullName}}" *ngFor="let route of filteredStateRoutes" [ngValue]="route">{{ route.displayText }}</option>
            </select>
        </label>
        <label>
            Seg Begin (Optional)
            <select class="select" [(ngModel)]="segment" name="segmentBegin" id="segmentBegin" [disabled]="!route">
                <option></option>
                <option *ngFor="let segment of segmentBegins" [ngValue]="segment">{{ segment.segmentNumber }}</option>
            </select>
        </label>
        <label>
            Seg End (Optional)
            <select class="select" [(ngModel)]="segmentEnd" name="segmentEnd" id="segmentEnd" [disabled]="!segment">
                <option *ngFor="let segmentEnd of segmentEnds" [ngValue]="segmentEnd.segmentNumber">
                    {{ segmentEnd.segmentNumber }}
                </option>
            </select>
        </label>
        <label *ngIf="showOffset">
            Offset (Optional)
            <input type="text" [(ngModel)]="offset" name="offset" [disabled]="!segment" />
        </label>
    </div>
</form>
